/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */

import {
    AfterViewInit,
    Component,
    ElementRef,
    HostBinding,
    HostListener,
    ViewEncapsulation,
    ChangeDetectionStrategy,
    inject,
    computed,
    signal,
    input,
    OnInit,
} from '@angular/core';
import { BazisMediaQueryService } from '@bazis/shared/services/media-query.service';

const SUPPORTS_VARS = !!(window.CSS && window.CSS.supports && window.CSS.supports('--a: 0'));
const BREAKPOINTS = ['', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
const isRTL = document.dir === 'rtl';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host { --bazis-grid-column-padding-start: var(--bazis-grid-column-padding); --bazis-grid-column-padding-start-xs: var(--bazis-grid-column-padding-xs); --bazis-grid-column-padding-start-sm: var(--bazis-grid-column-padding-start-xs, var(--bazis-grid-column-padding-sm)); --bazis-grid-column-padding-start-md: var(--bazis-grid-column-padding-start-sm, var(--bazis-grid-column-padding-md)); --bazis-grid-column-padding-start-lg: var(--bazis-grid-column-padding-start-md, var(--bazis-grid-column-padding-lg)); --bazis-grid-column-padding-start-xl: var(--bazis-grid-column-padding-start-lg, var(--bazis-grid-column-padding-xl)); --bazis-grid-column-padding-start-xxl: var(--bazis-grid-column-padding-start-xl, var(--bazis-grid-column-padding-xxl)); --bazis-grid-column-padding-end: var(--bazis-grid-column-padding); --bazis-grid-column-padding-end-xs: var(--bazis-grid-column-padding-xs); --bazis-grid-column-padding-end-sm: var(--bazis-grid-column-padding-end-xs, var(--bazis-grid-column-padding-sm)); --bazis-grid-column-padding-end-md: var(--bazis-grid-column-padding-end-sm, var(--bazis-grid-column-padding-md)); --bazis-grid-column-padding-end-lg: var(--bazis-grid-column-padding-end-md, var(--bazis-grid-column-padding-lg)); --bazis-grid-column-padding-end-xl: var(--bazis-grid-column-padding-end-lg, var(--bazis-grid-column-padding-xl)); --bazis-grid-column-padding-end-xxl: var(--bazis-grid-column-padding-end-xl, var(--bazis-grid-column-padding-xxl)); --bazis-grid-column-padding-top: var(--bazis-grid-column-padding); --bazis-grid-column-padding-top-xs: var(--bazis-grid-column-padding-xs); --bazis-grid-column-padding-top-sm: var(--bazis-grid-column-padding-top-xs, var(--bazis-grid-column-padding-sm)); --bazis-grid-column-padding-top-md: var(--bazis-grid-column-padding-top-sm, var(--bazis-grid-column-padding-md)); --bazis-grid-column-padding-top-lg: var(--bazis-grid-column-padding-top-md, var(--bazis-grid-column-padding-lg)); --bazis-grid-column-padding-top-xl: var(--bazis-grid-column-padding-top-lg, var(--bazis-grid-column-padding-xl)); --bazis-grid-column-padding-top-xxl: var(--bazis-grid-column-padding-top-xl, var(--bazis-grid-column-padding-xxl)); --bazis-grid-column-padding-bottom: var(--bazis-grid-column-padding); --bazis-grid-column-padding-bottom-xs: var(--bazis-grid-column-padding-xs); --bazis-grid-column-padding-bottom-sm: var(--bazis-grid-column-padding-bottom-xs, var(--bazis-grid-column-padding-sm)); --bazis-grid-column-padding-bottom-md: var(--bazis-grid-column-padding-bottom-sm, var(--bazis-grid-column-padding-md)); --bazis-grid-column-padding-bottom-lg: var(--bazis-grid-column-padding-bottom-md, var(--bazis-grid-column-padding-lg)); --bazis-grid-column-padding-bottom-xl: var(--bazis-grid-column-padding-bottom-lg, var(--bazis-grid-column-padding-xl)); --bazis-grid-column-padding-bottom-xxl: var(--bazis-grid-column-padding-bottom-xl, var(--bazis-grid-column-padding-xxl)); padding-left: var(--bazis-grid-column-padding-start-xs, var(--bazis-grid-column-padding-start, 5px)); padding-right: var(--bazis-grid-column-padding-end-xs, var(--bazis-grid-column-padding-end, 5px)); padding-top: var(--bazis-grid-column-padding-top-xs, var(--bazis-grid-column-padding-top, 5px)); padding-bottom: var(--bazis-grid-column-padding-bottom-xs, var(--bazis-grid-column-padding-bottom, 5px)); margin-left: 0; margin-right: 0; margin-top: 0; margin-bottom: 0; box-sizing: border-box; position: relative; flex-basis: 0; flex-grow: 1; width: 100%; max-width: 100%; min-height: 1px; } @supports (margin-inline-start: 0) or (-webkit-margin-start: 0) { :host { padding-left: unset; padding-right: unset; -webkit-padding-start: var(--bazis-grid-column-padding-start-xs, var(--bazis-grid-column-padding-start, 5px)); padding-inline-start: var(--bazis-grid-column-padding-start-xs, var(--bazis-grid-column-padding-start, 5px)); -webkit-padding-end: var(--bazis-grid-column-padding-end-xs, var(--bazis-grid-column-padding-end, 5px)); padding-inline-end: var(--bazis-grid-column-padding-end-xs, var(--bazis-grid-column-padding-end, 5px)); } } @media (min-width: 576.98px) { :host { padding-left: var(--bazis-grid-column-padding-start-sm, var(--bazis-grid-column-padding-start, 5px)); padding-right: var(--bazis-grid-column-padding-end-sm, var(--bazis-grid-column-padding-end, 5px)); padding-top: var(--bazis-grid-column-padding-top-sm, var(--bazis-grid-column-padding-top, 5px)); padding-bottom: var(--bazis-grid-column-padding-bottom-sm, var(--bazis-grid-column-padding-bottom, 5px)); } @supports (margin-inline-start: 0) or (-webkit-margin-start: 0) { :host { padding-left: unset; padding-right: unset; -webkit-padding-start: var(--bazis-grid-column-padding-start-sm, var(--bazis-grid-column-padding-start, 5px)); padding-inline-start: var(--bazis-grid-column-padding-start-sm, var(--bazis-grid-column-padding-start, 5px)); -webkit-padding-end: var(--bazis-grid-column-padding-end-sm, var(--bazis-grid-column-padding-end, 5px)); padding-inline-end: var(--bazis-grid-column-padding-end-sm, var(--bazis-grid-column-padding-end, 5px)); } } } @media (min-width: 768.98px) { :host { padding-left: var(--bazis-grid-column-padding-start-md, var(--bazis-grid-column-padding-start, 5px)); padding-right: var(--bazis-grid-column-padding-end-md, var(--bazis-grid-column-padding-end, 5px)); padding-top: var(--bazis-grid-column-padding-top-md, var(--bazis-grid-column-padding-top, 5px)); padding-bottom: var(--bazis-grid-column-padding-bottom-md, var(--bazis-grid-column-padding-bottom, 5px)); } @supports (margin-inline-start: 0) or (-webkit-margin-start: 0) { :host { padding-left: unset; padding-right: unset; -webkit-padding-start: var(--bazis-grid-column-padding-start-md, var(--bazis-grid-column-padding-start, 5px)); padding-inline-start: var(--bazis-grid-column-padding-start-md, var(--bazis-grid-column-padding-start, 5px)); -webkit-padding-end: var(--bazis-grid-column-padding-end-md, var(--bazis-grid-column-padding-end, 5px)); padding-inline-end: var(--bazis-grid-column-padding-end-md, var(--bazis-grid-column-padding-end, 5px)); } } } @media (min-width: 992.98px) { :host { padding-left: var(--bazis-grid-column-padding-start-lg, var(--bazis-grid-column-padding-start, 5px)); padding-right: var(--bazis-grid-column-padding-end-lg, var(--bazis-grid-column-padding-end, 5px)); padding-top: var(--bazis-grid-column-padding-top-lg, var(--bazis-grid-column-padding-top, 5px)); padding-bottom: var(--bazis-grid-column-padding-bottom-lg, var(--bazis-grid-column-padding-bottom, 5px)); } @supports (margin-inline-start: 0) or (-webkit-margin-start: 0) { :host { padding-left: unset; padding-right: unset; -webkit-padding-start: var(--bazis-grid-column-padding-start-lg, var(--bazis-grid-column-padding-start, 5px)); padding-inline-start: var(--bazis-grid-column-padding-start-lg, var(--bazis-grid-column-padding-start, 5px)); -webkit-padding-end: var(--bazis-grid-column-padding-end-lg, var(--bazis-grid-column-padding-end, 5px)); padding-inline-end: var(--bazis-grid-column-padding-end-lg, var(--bazis-grid-column-padding-end, 5px)); } } } @media (min-width: 1024.98px) { :host { padding-left: var(--bazis-grid-column-padding-start-xl, var(--bazis-grid-column-padding-start, 5px)); padding-right: var(--bazis-grid-column-padding-end-xl, var(--bazis-grid-column-padding-end, 5px)); padding-top: var(--bazis-grid-column-padding-top-xl, var(--bazis-grid-column-padding-top, 5px)); padding-bottom: var(--bazis-grid-column-padding-bottom-xl, var(--bazis-grid-column-padding-bottom, 5px)); } @supports (margin-inline-start: 0) or (-webkit-margin-start: 0) { :host { padding-left: unset; padding-right: unset; -webkit-padding-start: var(--bazis-grid-column-padding-start-xl, var(--bazis-grid-column-padding-start, 5px)); padding-inline-start: var(--bazis-grid-column-padding-start-xl, var(--bazis-grid-column-padding-start, 5px)); -webkit-padding-end: var(--bazis-grid-column-padding-end-xl, var(--bazis-grid-column-padding-end, 5px)); padding-inline-end: var(--bazis-grid-column-padding-end-xl, var(--bazis-grid-column-padding-end, 5px)); } } } @media (min-width: 1200px) { :host { padding-left: var(--bazis-grid-column-padding-start-xxl, var(--bazis-grid-column-padding-start, 5px)); padding-right: var(--bazis-grid-column-padding-end-xxl, var(--bazis-grid-column-padding-end, 5px)); padding-top: var(--bazis-grid-column-padding-top-xxl, var(--bazis-grid-column-padding-top, 5px)); padding-bottom: var(--bazis-grid-column-padding-bottom-xxl, var(--bazis-grid-column-padding-bottom, 5px)); } @supports (margin-inline-start: 0) or (-webkit-margin-start: 0) { :host { padding-left: unset; padding-right: unset; -webkit-padding-start: var(--bazis-grid-column-padding-start-xxl, var(--bazis-grid-column-padding-start, 5px)); padding-inline-start: var(--bazis-grid-column-padding-start-xxl, var(--bazis-grid-column-padding-start, 5px)); -webkit-padding-end: var(--bazis-grid-column-padding-end-xxl, var(--bazis-grid-column-padding-end, 5px)); padding-inline-end: var(--bazis-grid-column-padding-end-xxl, var(--bazis-grid-column-padding-end, 5px)); } } }`,
);

@Component({
    selector: 'bazis-col',
    template: '<slot></slot>',
    // styleUrls: ['col.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ColElement implements AfterViewInit, OnInit {
    public el = inject(ElementRef);

    private mqSrv = inject(BazisMediaQueryService);

    readonly offset = input<string>();

    readonly offsetXs = input<string>();

    readonly offsetSm = input<string>();

    readonly offsetMd = input<string>();

    readonly offsetLg = input<string>();

    readonly offsetXl = input<string>();

    readonly offsetXxl = input<string>();

    readonly pull = input<string>();

    readonly pullXs = input<string>();

    readonly pullSm = input<string>();

    readonly pullMd = input<string>();

    readonly pullLg = input<string>();

    readonly pullXl = input<string>();

    readonly pullXxl = input<string>();

    readonly push = input<string>();

    readonly pushXs = input<string>();

    readonly pushSm = input<string>();

    readonly pushMd = input<string>();

    readonly pushLg = input<string>();

    readonly pushXl = input<string>();

    readonly pushXxl = input<string>();

    readonly size = input<string>();

    readonly sizeXs = input<string>();

    readonly sizeSm = input<string>();

    readonly sizeMd = input<string>();

    readonly sizeLg = input<string>();

    readonly sizeXl = input<string>();

    readonly sizeXxl = input<string>();

    @HostListener('window:resize') onResize() {
        this._needUpdate.set(this._needUpdate() + 1);
    }

    @HostBinding('style') get style() {
        return this.colStyle();
    }

    private _needUpdate = signal(0);

    colStyle = computed(() => {
        this._needUpdate(); // to trigger computed
        return {
            ...this.calculateSize(),
            ...this.calculatePush(),
            ...this.calculatePull(),
            ...this.calculateOffset(),
        };
    });

    ngOnInit(): void {
        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }

    ngAfterViewInit(): void {
        this._needUpdate.set(this._needUpdate() + 1);
    }

    private getColumns(property) {
        let matched;
        for (const breakpoint of BREAKPOINTS) {
            const matches = this.mqSrv.matchBreakpoint(breakpoint);
            // Grab the value of the property, if it exists and our
            // media query matches we return the value
            const columns =
                this[property + breakpoint.charAt(0).toUpperCase() + breakpoint.slice(1)]();
            if (matches && columns !== undefined) {
                matched = columns;
            }
        }
        // Return the last matched columns since the breakpoints
        // increase in size and we want to return the largest match
        return matched;
    }

    private calculateSize() {
        const columns = this.getColumns('size');
        // If size wasn't set for any breakpoint
        // or if the user set the size without a value
        // it means we need to stick with the default and return
        // e.g. <nc-col size-md>
        if (!columns || columns === '') {
            return;
        }
        // If the size is set to auto then don't calculate a size
        const colSize =
            columns === 'auto'
                ? 'auto'
                : // If CSS supports variables we should use the grid columns var
                  SUPPORTS_VARS
                  ? `calc(calc(${columns} / var(--bazis-grid-columns, 12)) * 100%)`
                  : // Convert the columns to a percentage by dividing by the total number
                    // of columns (12) and then multiplying by 100
                    (columns / 12) * 100 + '%';
        return {
            flex: `0 0 ${colSize}`,
            width: `${colSize}`,
            'max-width': `${colSize}`,
        };
    }

    // Called by push, pull, and offset since they use the same calculations
    private calculatePosition(property, modifier) {
        const columns = this.getColumns(property);
        if (!columns) {
            return;
        }
        // If the number of columns passed are greater than 0 and less than
        // 12 we can position the column, else default to auto
        const amount = SUPPORTS_VARS
            ? // If CSS supports variables we should use the grid columns var
              `calc(calc(${columns} / var(--bazis-grid-columns, 12)) * 100%)`
            : // Convert the columns to a percentage by dividing by the total number
              // of columns (12) and then multiplying by 100
              columns > 0 && columns < 12
              ? (columns / 12) * 100 + '%'
              : 'auto';
        return {
            [modifier]: amount,
        };
    }

    private calculateOffset() {
        return this.calculatePosition('offset', isRTL ? 'margin-right' : 'margin-left');
    }

    private calculatePull() {
        return this.calculatePosition('pull', isRTL ? 'left' : 'right');
    }

    private calculatePush() {
        return this.calculatePosition('push', isRTL ? 'right' : 'left');
    }
}
